<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <qrcode [qrdata]="data.data" [width]="512" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()" cdkFocusInitial>Close</button>
</div>